import React, { useEffect, useState } from "react";
import UserList from "../components/UserList";
import UserModal from "../components/UserModal";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";

const UserManagement = () => {
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [showUserModal, setShowUserModal] = useState(false);
    const [universities, setUniversities] = useState([]);
    const [isLoadingUniversities, setIsLoadingUniversities] = useState(false); // Loading state for universities
    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_BASE_URL;

    const role = localStorage.getItem("role");
    const universityId = localStorage.getItem("universityId");

    const handleLogout = (event) => {
        event.preventDefault();
        console.log("Navigating to /login...");
        localStorage.clear();
        navigate("/login");
    };

    const fetchUniversities = async () => {
        if (role === "super_admin") {
            setIsLoadingUniversities(true);
            try {
                const response = await fetch(`${apiUrl}/universities`);
                if (!response.ok) throw new Error("Failed to fetch universities.");
                const data = await response.json();
                setUniversities(data);
            } catch (error) {
                console.error("Error fetching universities:", error);
                setUniversities([]);
            } finally {
                setIsLoadingUniversities(false);
            }
        }
    };

    useEffect(() => {
        fetchUniversities();
    }, []); // Fetch universities on component mount

    const handleAddUser = () => {
        setSelectedUser(null); // Clear the selected user for new user creation
        setShowUserModal(true);
    };

    const handleEditUser = async (user) => {
        console.log("Editing user:", user);
        if (role === "super_admin" && universities.length === 0) {
            await fetchUniversities(); // Ensure universities are fetched for super admin
        }
        setSelectedUser(user); // Set the selected user for editing
        setShowUserModal(true);
    };

    const handleSaveUser = () => {
        setShowUserModal(false); // Close the modal after saving
        const fetchUsers = async () => {
            const endpoint =
                role === "super_admin"
                    ? `${apiUrl}/users`
                    : `${apiUrl}/users/university/${universityId}`;
            try {
                const response = await fetch(endpoint);
                const data = await response.json();
                setUsers(data);
            } catch (error) {
                console.error("Error fetching users:", error);
            }
        };
        fetchUsers();
    };

    return (
        <div className="dashboard">
            <Sidebar/>
            <main className="main-content">
                <div>
                    <header className="header component">
                        <span className="component-header">Users</span>
                        <button className="btn btn-primary action" onClick={handleAddUser}>
                            <i className="fa fa-plus"></i> New User
                        </button>
                    </header>
                    <hr />
                    <UserList
                        users={users}
                        onEdit={handleEditUser}
                    />
                    {showUserModal && (
                        <UserModal
                            user={selectedUser}
                            universities={universities}
                            role={role}
                            onClose={() => setShowUserModal(false)}
                            onSave={handleSaveUser}
                        />
                    )}
                </div>
            </main>
        </div>
    );
};

export default UserManagement;